import { GlobalSearchComponent } from './components/global-search/global-search/global-search.component';
import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { HomeComponent } from './components/core/home/home.component';
import { AuthorizationComponent } from './components/lead-details/authorization/authorization.component';
import { MemberViewComponent } from './components/lead-details/member-view/member-view.component';
import { LeadInformationComponent } from './components/lead-details/participant-information/lead-information/lead-information.component';
import { CommPreferenceComponent } from './components/leads/comm-preference/comm-preference.component';
import { ContactDetailsComponent } from './components/leads/contact-details/contact-details.component';
import { NewReferralComponent } from './components/leads/new-referral/new-referral.component';
import { ParticipantInformationComponent } from './components/leads/participant-information/participant-information.component';
import { ReferralLogicComponent } from './components/leads/referral-logic/referral-logic.component';
import { SummaryComponent } from './components/leads/summary/summary.component';
import { ParticipantLeadsListComponent } from './components/participant-leads-list/participant-leads-list.component';
import { ParticipantLeadsComponent } from './components/participant-leads/participant-leads.component';
import { ProviderLeadsListComponent } from './components/provider-leads-list/provider-leads-list.component';
import { MessageComponent } from './shared/components/message/message.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { EnrollmentListComponent } from './components/enrollment/enrollment-list/enrollment-list.component';
import { EnrollmentListComponentOld } from './components/enrollment/enrollment-list_old/enrollment-list.component';
import { NewEnrollmentComponent } from './components/enrollment/new-enrollment/new-enrollment.component';
import { ParticipantEnrollmentListComponent } from './components/enrollment/participant-enrollment-list/participant-enrollment-list.component';
import { PaymentDetailsComponent } from './components/enrollment/payment-details/payment-details.component';
import { ProviderEnrollmentListComponent } from './components/enrollment/provider-enrollment-list/provider-enrollment-list.component';
import { AdditionalAttributesComponent } from './components/lead-details/additional-attributes/additional-attributes.component';
import { AssociationsComponent } from './components/lead-details/associations/associations.component';
import { ChecklistComponent } from './components/lead-details/check-list/ppl-checklist/checklist.component';
import { CommunicationDetailsComponent } from './components/lead-details/communication-details/communication-details/communication-details.component';
import { DocumentsComponent } from './components/lead-details/documents/documents/documents.component';
import { EmployerComponent } from './components/lead-details/employer/employer/employer.component';
import { LeadDetailSignatureComponent } from './components/lead-details/lead-detail-signature/lead-detail-signature.component';
import { ProspectiveParticipantsComponent } from './components/lead-details/prospective-participants/prospective-participants/prospective-participants.component';
import { LeadDetailSummaryComponent } from './components/lead-details/summary/lead-detail-summary/lead-detail-summary.component';
import { ToDoListComponent } from './components/lead-details/to-do-list/to-do-list/to-do-list.component';
import { FormChecklistComponent } from './components/leads/form-checklist/form-checklist.component';
import { NewContactComponent } from './components/leads/new-contact/new-contact.component';
import { ServiceDetailsComponent } from './components/leads/service-details/service-details.component';
import { UploadDocsComponent } from './components/leads/upload-docs/upload-docs.component';
import { UploadSignaturesComponent } from './components/leads/upload-signatures/upload-signatures.component';
import { ReferralListComponent } from './components/referral/referral-list/referral-list.component';
import { ReferralsComponent } from './components/referral/referrals/referrals.component';
import { AuthGuard } from './shared/authorization/auth.gaurd';
import {
  clearListSharedDataGuard,
  clearParticipantLeadSharedDataGaurd,
} from './shared/can-deactivate-gaurd';
import { ProcessCodeListComponent } from './components/payroll/process-codes/process-code-list/process-code-list.component';
import { AddProcessCodeComponent } from './components/payroll/process-codes/add-process-code/add-process-code.component';
import { ServiceCodeListComponent } from './components/payroll/service-codes/service-code-list/service-code-list.component';
import { AddServiceCodeComponent } from './components/payroll/service-codes/add-service-code/add-service-code.component';
import { ParticipantProviderRatesListComponent } from './components/payroll/participant-provider-rates/participant-provider-rates-list/participant-provider-rates-list.component';
import { AddParticipantProviderRatesComponent } from './components/payroll/participant-provider-rates/add-participant-provider-rates/add-participant-provider-rates.component';
import { AuthorizationsListComponent } from './components/payroll/authorizations/authorizations-list/authorizations-list.component';
import { AddAuthorizationComponent } from './components/payroll/authorizations/add-authorization/add-authorization.component';
import { AuthorizationDetailsComponent } from './components/payroll/authorizations/authorization-details/authorization-details.component';
import { FileTriageListComponent } from './components/fileTriage/file-triage-list/file-triage-list.component';
import { AuthorizationMemberViewComponent } from './components/payroll/authorizations/authorization-member-view/authorization-member-view.component';
import { PayableProviderRatesListComponent } from './components/payroll/payable-provider-rates/payable-provider-rates-list/payable-provider-rates-list.component';
import { BillableProviderRatesListComponent } from './components/payroll/billable-provider-rates/billable-provider-rates-list/billable-provider-rates-list.component';
import { AddPayableProviderRatesComponent } from './components/payroll/payable-provider-rates/add-payable-provider-rates/add-payable-provider-rates.component';
import { AddBillableProviderRatesComponent } from './components/payroll/billable-provider-rates/add-billable-provider-rates/add-billable-provider-rates.component';
import { FileUploadNotificationListComponent } from './components/file-upload-notification/file-upload-notification-list/file-upload-notification-list.component';
import { BenefitsComponent } from './components/lead-details/benefits/benefits.component';
import { CaseManagerListComponent } from './components/case-manager/case-manager-list/case-manager-list.component';
import { CaseManagerDetailsComponent } from './components/case-manager/case-manager-details/case-manager-details.component';
import { TimesheetStaffListComponent } from './components/payroll/timesheets/timesheet-staff-list/timesheet-staff-list.component';
import { TimesheetProviderListComponent } from './components/payroll/timesheets/timesheet-provider-list/timesheet-provider-list.component';
import { TimesheetConsumerListComponent } from './components/payroll/timesheets/timesheet-consumer-list/timesheet-consumer-list.component';
import { PayrollProcessingComponent } from './components/payroll/payroll-processing/payroll-processing.component';
import { TimesheetDetailComponent } from './components/payroll/timesheets/timesheet-detail-component/timesheet-detail.component';
import { ViewBatchesComponent } from './components/billing/batches/view-batches/view-batches.component';
import { BatchesListComponent } from './components/billing/batches/batches-list/batches-list.component';
import { ViewClaimsComponent } from './components/billing/claims/view-claims/view-claims.component';
import { ViewFilesComponent } from './components/billing/files/view-files/view-files.component';
import { FilesListComponent } from './components/billing/files/files-list/files-list.component';
import { ClaimsListComponent } from './components/billing/claims/claims-list/claims-list.component';
import { BillingPmpmClaimsListComponent } from './components/billing/claims/billing-pmpm-claims-list/billing-pmpm-claims-list.component';
import { PmpmClaimsComponent } from './components/billing/claims/pmpm-claims/pmpm-claims.component';
import { ViewReconFilesComponent } from './components/billing/recon-files/view-recon-files/view-recon-files.component';
import { ReconFilesListComponent } from './components/billing/recon-files/recon-files-list/recon-files-list.component';
import { ViewPaymentReconComponent } from './components/billing/payment-recon/view-payment-recon/view-payment-recon.component';
import { PaymentReconListComponent } from './components/billing/payment-recon/payment-recon-list/payment-recon-list.component';
import { PayrollNatPayListComponent } from './components/natPay/payroll-nat-pay-list/payroll-nat-pay-list.component';
import { TimesheetPendedListComponent } from './components/payroll/timesheets/timesheet-pended-list/timesheet-pended-list.component';
import { ViewCDRComponent } from './components/billing/cdr-recon/view-cdr/view-cdr.component';
import { CdrListComponent } from './components/billing/cdr-recon/cdr-list/cdr-list.component';
import { DenialReportComponent } from './components/billing/reports/denial-report/denial-report.component';
import { ActivityReportComponent } from './components/billing/reports/activity-report/activity-report.component';
import { SummaryReportComponent } from './components/billing/reports/summary-report/summary-report.component';
import { IgnoredTimesheetReportComponent } from './components/billing/reports/ignored-timesheet-report/ignored-timesheet-report.component';
import { BatchReportComponent } from './components/billing/reports/batch-report/batch-report.component';
import { IgnoredTimesheetsListComponent } from './components/billing/ignored-timesheet-list-page/ignored-timesheets-list/ignored-timesheets-list.component';
import { ResubmissionReportComponent } from './components/billing/resubmission-report/resubmission-report.component';
import { TimesheetPayrollAdjustmentComponent } from './components/payroll/timesheets/timesheet-payroll-adjustment/timesheet-payroll-adjustment.component';
import { TimesheetBillingAdjustmentComponent } from './components/payroll/timesheets/timesheet-billing-adjustment/timesheet-billing-adjustment.component';
import { AddConfigComponent } from './components/config/add-config/add-config.component';
import { ConfigListComponent } from './components/config/config-list/config-list.component';
import { ConfigViewComponent } from './components/config/config-view/config-view.component';
import { LookupConfigListComponent } from './components/config/lookup-config-list/lookup-config-list.component';
import { TimesheetPayrollAdjustmentApprovalsComponent } from './components/payroll/timesheets/timesheet-payroll-adjustment-approvals/timesheet-payroll-adjustment-approvals.component';
import { TimesheetBillingAdjustmentApprovalsComponent } from './components/payroll/timesheets/timesheet-billing-adjustment-approvals/timesheet-billing-adjustment-approvals.component';
import { ViewWorkdayComponent } from './components/billing/workday/view-workday/view-workday.component';
import { WorkdayListComponent } from './components/billing/workday/workday-list/workday-list.component';
import { ViewWorkdayInvoiceComponent } from './components/billing/workday-invoice/view-workday-invoice/view-workday-invoice.component';
import { WorkdayInvoiceListComponent } from './components/billing/workday-invoice/workday-invoice-list/workday-invoice-list.component';
import { ViewWorkdayPaymentComponent } from './components/billing/workday-payment/view-workday-payment/view-workday-payment.component';
import { WorkdayPaymentListComponent } from './components/billing/workday-payment/workday-payment-list/workday-payment-list.component';
import { AuthUtilizationAnalysisComponent } from './components/payroll/authorizations/auth-utilization-analysis/auth-utilization-analysis.component';
import { ViewWorkdayStatusComponent } from './components/billing/workday-status/view-workday-status/view-workday-status.component';
import { WorkdayStatusListComponent } from './components/billing/workday-status/workday-status-list/workday-status-list.component';
import { TimesheetPayrollResurrectComponent } from './components/payroll/timesheets/timesheet-payroll-resurrect/timesheet-payroll-resurrect.component';
import { BillingClaimAdjustmentComponent } from './components/payroll/claim-adjustment/billing-claim-adjustment/billing-claim-adjustment.component';
import { TaxDocumentsComponent } from './components/lead-details/tax-documents/tax-documents.component';
import { ViewLedgerComponent } from './components/billing/ledger/view-ledger/view-ledger.component';
import { LedgerListComponent } from './components/billing/ledger/ledger-list/ledger-list.component';
import { ViewPatientLedgerComponent } from './components/billing/patient-ledger/view-patient-ledger/view-patient-ledger.component';
import { PatientLedgerListComponent } from './components/billing/patient-ledger/patient-ledger-list/patient-ledger-list.component';
import { ViewDepositEntryComponent } from './components/billing/deposit-entry/view-deposit-entry/view-deposit-entry.component';
import { DepositEntryListComponent } from './components/billing/deposit-entry/deposit-entry-list/deposit-entry-list.component';
import { ViewGlobalLedgerComponent } from './components/billing/global-ledger/view-global-ledger/view-global-ledger.component';
import { GlobalLedgerListComponent } from './components/billing/global-ledger/global-ledger-list/global-ledger-list.component';

export const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    children: [
      {
        path: 'participantLeadsList',
        component: ParticipantLeadsComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ParticipantLeadsListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [clearListSharedDataGuard],
          },
          {
            path: 'leadDetails',
            component: MemberViewComponent,
            canActivate: [AuthGuard],
            children: [
              {
                path: 'participantInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'ppl-authorization',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'authorization',
                component: AuthorizationComponent,
                data: {
                  breadcrumb: 'Authorization',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'employers',
                component: EmployerComponent,
                data: {
                  breadcrumb: 'Employers',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'timesheets',
                component: TimesheetProviderListComponent,
                data: {
                  breadcrumb: 'Timesheets',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'documents',
                component: DocumentsComponent,
                data: {
                  breadcrumb: 'Documents',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'communicationDetails',
                component: CommunicationDetailsComponent,
                data: {
                  breadcrumb: 'Communication Details',
                },
                canActivate: [AuthGuard],
              },
            ],
          },
        ],
        data: {
          breadcrumb: 'Participant Leads',
        },
        canDeactivate: [clearParticipantLeadSharedDataGaurd],
      },
      {
        path: 'providerLeadsList',
        component: ParticipantLeadsComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ProviderLeadsListComponent,
            pathMatch: 'full',
            canDeactivate: [clearListSharedDataGuard],
            canActivate: [AuthGuard],
          },

          {
            path: 'leadDetails',
            component: MemberViewComponent,
            children: [
              {
                path: 'participantInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'Participant Information',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'documents',
                component: DocumentsComponent,
                data: {
                  breadcrumb: 'Documents',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'prospectiveParticipants',
                component: ProspectiveParticipantsComponent,
                data: {
                  breadcrumb: 'Prospective Participants',
                },
                canActivate: [AuthGuard],
              },
            ],
          },
        ],
        data: {
          breadcrumb: 'Provider Leads List',
        },
      },
      {
        path: 'participantEnrollmentList',
        component: ParticipantLeadsComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ParticipantEnrollmentListComponent,
            pathMatch: 'full',
            canDeactivate: [clearListSharedDataGuard],
            canActivate: [],
          },
          {
            path: 'details',
            component: MemberViewComponent,
            children: [
              {
                path: 'summary',
                component: LeadDetailSummaryComponent,
                data: {
                  breadcrumb: 'Summary',
                },
                canActivate: [],
              },
              {
                path: 'enrollmentInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'Basic Information',
                },
                canActivate: [],
              },
              {
                path: 'toDoList',
                component: ToDoListComponent,
                data: {
                  breadcrumb: 'To Do List',
                },
                canActivate: [],
              },
              {
                path: 'authorizations',
                component: AuthorizationComponent,
                data: {
                  breadcrumb: 'Authorizations',
                },
                canActivate: [],
              },

              {
                path: 'forms',
                component: FormChecklistComponent,
                data: {
                  breadcrumb: 'Forms',
                },
                canActivate: [],
              },
              {
                path: 'employers',
                component: EmployerComponent,
                data: {
                  breadcrumb: '',
                },
                canActivate: [],
              },
              {
                path: 'timesheets',
                component: TimesheetConsumerListComponent,
                data: {
                  breadcrumb: 'Timesheets',
                },
                canActivate: [],
              },
              {
                path: 'documents',
                component: DocumentsComponent,
                data: {
                  breadcrumb: 'Documents',
                },
                canActivate: [],
              },
              {
                path: 'checklist',
                component: ChecklistComponent,
                data: {
                  breadcrumb: 'Checklist',
                  isParticipant: true,
                },
                canActivate: [],
              },
              {
                path: 'associations',
                component: AssociationsComponent,
                data: {
                  breadcrumb: 'Associations',
                },
                canActivate: [],
              },
              {
                path: 'signature',
                component: LeadDetailSignatureComponent,
                data: {
                  breadcrumb: 'Signature',
                },
                canActivate: [],
              },
              {
                path: 'additionalAttributes',
                component: AdditionalAttributesComponent,
                data: {
                  breadcrumb: 'Additional Attributes',
                },
                canActivate: [],
              },
            ]
          }]
      },
      {
        path: 'globalConsumerSearch',
        component: ParticipantLeadsComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: GlobalSearchComponent,
            pathMatch: 'full',
            canDeactivate: [],
            canActivate: [],
          },
          {
            path: 'details',
            component: MemberViewComponent,
            children: [
              {
                path: 'summary',
                component: LeadDetailSummaryComponent,
                data: {
                  breadcrumb: 'Authorization',
                },
                canActivate: [],
              },
              {
                path: 'enrollmentInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'ppl-authorization',
                },
                canActivate: [],
              },

              {
                path: 'participantInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'Participant Information',
                },
                canActivate: [],
              },
              {
                path: 'toDoList',
                component: ToDoListComponent,
                data: {
                  breadcrumb: 'To Do List',
                },
                canActivate: [],
              },
              {
                path: 'authorizations',
                component: AuthorizationComponent,
                data: {
                  breadcrumb: 'Authorizations',
                },
                canActivate: [],
              },

              {
                path: 'forms',
                component: FormChecklistComponent,
                data: {
                  breadcrumb: 'Forms',
                },
                canActivate: [],
              },
              {
                path: 'employers',
                component: EmployerComponent,
                data: {
                  breadcrumb: '',
                },
                canActivate: [],
              },
              {
                path: 'timesheets',
                component: TimesheetConsumerListComponent,
                data: {
                  breadcrumb: 'Timesheets',
                },
                canActivate: [],
              },
              {
                path: 'documents',
                component: DocumentsComponent,
                data: {
                  breadcrumb: 'Documents',
                },
                canActivate: [],
              },
              {
                path: 'checklist',
                component: ChecklistComponent,
                data: {
                  breadcrumb: 'Checklist',
                  isParticipant: true,
                },
                canActivate: [],
              },
              {
                path: 'associations',
                component: AssociationsComponent,
                data: {
                  breadcrumb: 'Associations',
                },
                canActivate: [],
              },
              {
                path: 'signature',
                component: LeadDetailSignatureComponent,
                data: {
                  breadcrumb: 'Signature',
                },
                canActivate: [],
              },
              {
                path: 'additionalAttributes',
                component: AdditionalAttributesComponent,
                data: {
                  breadcrumb: 'Additional Attributes',
                },
                canActivate: [],
              },
            ]
          }]
      },
      {
        path: 'providerEnrollmentList',
        component: ParticipantLeadsComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ProviderEnrollmentListComponent,
            pathMatch: 'full',
            canDeactivate: [clearListSharedDataGuard],
            canActivate: [],
          },
          {
            path: 'details',
            component: MemberViewComponent,
            children: [
              {
                path: 'summary',
                component: LeadDetailSummaryComponent,
                data: {
                  breadcrumb: 'Authorization',
                },
                canActivate: [],
              },
              {
                path: 'enrollmentInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'ppl-authorization',
                },
                canActivate: [],
              },
              {
                path: 'toDoList',
                component: ToDoListComponent,
                data: {
                  breadcrumb: 'To Do List',
                },
                canActivate: [],
              },
              {
                path: 'authorization',
                component: AuthorizationComponent,
                data: {
                  breadcrumb: 'Authorization',
                },
                canActivate: [],
              },
              {
                path: 'taxDocuments',
                component: TaxDocumentsComponent,
                data: {
                  breadcrumb: 'Tax & 401 Documents',
                },
                canActivate: [],
              },
              {
                path: 'forms',
                component: FormChecklistComponent,
                data: {
                  breadcrumb: 'Forms',
                },
                canActivate: [],
              },
              {
                path: 'employers',
                component: EmployerComponent,
                data: {
                  breadcrumb: '',
                },
                canActivate: [],
              },
              {
                path: 'timesheets',
                component: TimesheetProviderListComponent,
                data: {
                  breadcrumb: 'Timesheets',
                },
                canActivate: [],
              },
              {
                path: 'benefits',
                component: BenefitsComponent,
                data: {
                  breadcrumb: 'Benefits',
                },
                canActivate: [],
              },
              {
                path: 'documents',
                component: DocumentsComponent,
                data: {
                  breadcrumb: 'Documents',
                },
                canActivate: [],
              },
              {
                path: 'checklist',
                component: ChecklistComponent,
                data: {
                  breadcrumb: 'Checklist',
                  isParticipant: false
                },
                canActivate: [],
              },
              {
                path: 'associations',
                component: AssociationsComponent,
                data: {
                  breadcrumb: 'Associations',
                },
                canActivate: [],
              },
              {
                path: 'signature',
                component: LeadDetailSignatureComponent,
                data: {
                  breadcrumb: 'Signature',
                },
                canActivate: [],
              },
              {
                path: 'additionalAttributes',
                component: AdditionalAttributesComponent,
                data: {
                  breadcrumb: 'Additional Attributes',
                },
                canActivate: [],
              },
            ]
          }]
      },
      {
        path: 'newEnrollment',
        component: NewReferralComponent,
        children: [
          {
            path: 'participant_info',
            component: ParticipantInformationComponent,
          },
          { path: 'contact_details', component: ContactDetailsComponent },
          { path: 'comm_preferences', component: CommPreferenceComponent },
          { path: 'service_details', component: ServiceDetailsComponent },
          { path: 'upload_docs', component: UploadDocsComponent },
          { path: 'signatures', component: UploadSignaturesComponent },
          { path: 'associations', component: NewContactComponent },
          { path: 'forms', component: FormChecklistComponent },
          { path: 'payment_details', component: PaymentDetailsComponent },
          { path: 'summary', component: SummaryComponent },
        ],
        canActivate: [AuthGuard],
      },
      { path: 'newEnrollmentForm/:flow', component: NewEnrollmentComponent },
      {
        path: 'payrollProcessing',
        component: PayrollProcessingComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: PayrollProcessingComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
          }
        ]
      },
      {
        path: 'consumerLedgerList',
        component: ViewPatientLedgerComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: PatientLedgerListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [],
          },
        ]
      },
      {       
        path: 'claimLedgerList',
        component: ViewLedgerComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: LedgerListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'depositEntryList',
        component: ViewDepositEntryComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: DepositEntryListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [],
          },
        ]
      },
      {       
        path: 'globalLedgerList',
        component: ViewGlobalLedgerComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: GlobalLedgerListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'claimBatchesList',
        component: ViewBatchesComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: BatchesListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'billingPmpmClaimsList',
        component: PmpmClaimsComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: BillingPmpmClaimsListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'viewClaimsList',
        component: ViewClaimsComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ClaimsListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'claimFilesList',
        component: ViewFilesComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: FilesListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'billingReconFilesList',
        component: ViewReconFilesComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ReconFilesListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'billingPaymentReconList',
        component: ViewPaymentReconComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: PaymentReconListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'cdrReconList',
        component: ViewCDRComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: CdrListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'workdayList',
        component: ViewWorkdayComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: WorkdayListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'workdayInvoiceList',
        component: ViewWorkdayInvoiceComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: WorkdayInvoiceListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'workdayPaymentList',
        component: ViewWorkdayPaymentComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: WorkdayPaymentListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'workdayStatusList',
        component: ViewWorkdayStatusComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: WorkdayStatusListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'denialBillingReport',
        component: DenialReportComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: DenialReportComponent,
            pathMatch: 'full',
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'activityBillingReport',
        component: ActivityReportComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ActivityReportComponent,
            pathMatch: 'full',
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'summaryBillingReport',
        component: SummaryReportComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: SummaryReportComponent,
            pathMatch: 'full',
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'ignoredTimesheetReport',
        component: IgnoredTimesheetReportComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: IgnoredTimesheetReportComponent,
            pathMatch: 'full',
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'batchReport',
        component: BatchReportComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: BatchReportComponent,
            pathMatch: 'full',
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'resubmissionReport',
        component: ResubmissionReportComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ResubmissionReportComponent,
            pathMatch: 'full',
            canDeactivate: [],
          },
        ]
      },
      {
        path: 'referralList',
        component: ReferralsComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ReferralListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [clearListSharedDataGuard],
          },
          {
            path: 'referralDetails',
            component: MemberViewComponent,
            canActivate: [AuthGuard],
            children: [
              {
                path: 'participantInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'Participant Information',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'authorization',
                component: AuthorizationComponent,
                data: {
                  breadcrumb: 'Authorization',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'employers',
                component: EmployerComponent,
                data: {
                  breadcrumb: 'Employers',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'timesheets',
                component: TimesheetProviderListComponent,
                data: {
                  breadcrumb: 'Timesheets',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'documents',
                component: DocumentsComponent,
                data: {
                  breadcrumb: 'Documents',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'communicationDetails',
                component: CommunicationDetailsComponent,
                data: {
                  breadcrumb: 'Communication Details',
                },
                canActivate: [AuthGuard],
              },
            ],
          },
        ],
        data: {
          breadcrumb: 'Referrals',
        },
      },
      {
        path: 'enrollmentDetails',
        component: MemberViewComponent,
        children: [
          {
            path: 'summary',
            component: LeadDetailSummaryComponent,
            data: {
              breadcrumb: 'Authorization',
            },
            canActivate: [],
          },
          {
            path: 'enrollmentInformation',
            component: LeadInformationComponent,
            data: {
              breadcrumb: 'ppl-authorization',
            },
            canActivate: [],
          },
          {
            path: 'benefits',
            component: BenefitsComponent,
            data: {
              breadcrumb: 'Benefits',
            },
            canActivate: [],
          },
          {
            path: 'toDoList',
            component: ToDoListComponent,
            data: {
              breadcrumb: 'To Do List',
            },
            canActivate: [],
          },
          {
            path: 'authorization',
            component: AuthorizationComponent,
            data: {
              breadcrumb: 'Authorization',
            },
            canActivate: [],
          },
          {
            path: 'employers',
            component: EmployerComponent,
            data: {
              breadcrumb: '',
            },
            canActivate: [],
          },
          {
            path: 'documents',
            component: DocumentsComponent,
            data: {
              breadcrumb: 'Documents',
            },
            canActivate: [],
          },
          {
            path: 'forms',
            component: FormChecklistComponent,
            data: {
              breadcrumb: 'Forms',
            },
            canActivate: [],
          },
          {
            path: 'checklist',
            component: ChecklistComponent,
            data: {
              breadcrumb: 'Checklist'
            },
            canActivate: [],
          },
          {
            path: 'associations',
            component: AssociationsComponent,
            data: {
              breadcrumb: 'Associations',
            },
            canActivate: [],
          },
          {
            path: 'timesheets',
            component: TimesheetDetailComponent,
            data: {
              breadcrumb: 'Timesheets',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'taxDocuments',
            component: TaxDocumentsComponent,
            data: {
              breadcrumb: 'Tax & 401 Documents',
            },
            canActivate: [],
          },
          {
            path: 'signature',
            component: LeadDetailSignatureComponent,
            data: {
              breadcrumb: 'Signature',
            },
            canActivate: [],
          },
          {
            path: 'additionalAttributes',
            component: AdditionalAttributesComponent,
            data: {
              breadcrumb: 'Additional Attributes',
            },
            canActivate: [],
          },
          {
            path: 'authorizations',
            component: AuthorizationComponent,
            data: {
              breadcrumb: 'Authorizations',
            },
            canActivate: [],
          },
        ],
      },
      { /* path: 'enrollmentList', component: EnrollmentsComponent, */
        path: 'enrollmentList',
        component: EnrollmentListComponentOld,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: EnrollmentListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
            canDeactivate: [clearListSharedDataGuard],
          },
          {
            path: 'referralDetails',
            component: MemberViewComponent,
            canActivate: [AuthGuard],
            children: [
              {
                path: 'participantInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'Participant Information',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'authorization',
                component: AuthorizationComponent,
                data: {
                  breadcrumb: 'Authorization',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'employers',
                component: EmployerComponent,
                data: {
                  breadcrumb: 'Employers',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'timesheets',
                component: TimesheetProviderListComponent,
                data: {
                  breadcrumb: 'Timesheets',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'documents',
                component: DocumentsComponent,
                data: {
                  breadcrumb: 'Documents',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'communicationDetails',
                component: CommunicationDetailsComponent,
                data: {
                  breadcrumb: 'Communication Details',
                },
                canActivate: [AuthGuard],
              },
            ],
          },
        ],
        data: {
          breadcrumb: 'Referrals',
        },
      },
      {
        path: 'processCode/:action',
        component: AddProcessCodeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'config/:action',
        component: AddConfigComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'timesheet',
        component: TimesheetStaffListComponent,
        data: {
          breadcrumb: 'timesheet',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'pendedTimesheets',
        component: TimesheetPendedListComponent,
        data: {
          breadcrumb: 'Pended Timesheets',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'payrollAdjustment',
        component: TimesheetPayrollAdjustmentComponent,
        data: {
          breadcrumb: 'Payroll Adjustment',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'payrollApprovals',
        component: TimesheetPayrollAdjustmentApprovalsComponent,
        data: {
          breadcrumb: 'Payroll Approvals',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'payrollResurrect',
        component: TimesheetPayrollResurrectComponent,
        data: {
          breadcrumb: 'Payroll Resurrect',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'processCodeList',
        component: ProcessCodeListComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ProcessCodeListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
          },
        ]
      },
      {
        path: 'configList',
        component: ConfigViewComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: 'applicationConfig',
            component: ConfigListComponent,
            data: {
              breadcrumb: 'Application Config',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'lookupConfig',
            component: LookupConfigListComponent,
            data: {
              breadcrumb: 'Lookup Config',
            },
            canActivate: [AuthGuard],
          },
        ]
      },
      {
        path: 'serviceCode/:action',
        component: AddServiceCodeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'serviceCodeList',
        component: ServiceCodeListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'caseManagerDetails',
        component: CaseManagerDetailsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'caseManagerList',
        component: CaseManagerListComponent,
        canActivate: [AuthGuard]
      },
      /* {
        path: 'authorizations',
        component: AuthorizationsListComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'Referrals',
        },
            children: [
              {
                path: 'participantInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'Participant Information',
                },
                canActivate: [AuthGuard],
              },
            ]
      }, */


      {
        path: 'authorizations',
        component: ParticipantLeadsComponent,
        children: [
          {
            path: '',
            component: AuthorizationsListComponent,
            pathMatch: 'full',
            canDeactivate: [],
            canActivate: [],
          },
          {
            path: 'details',
            component: AuthorizationMemberViewComponent,
            children: [
              {
                path: 'authorization',
                component: AuthorizationDetailsComponent,
                data: {
                  breadcrumb: 'Authorization',
                },
                canActivate: [],
              },

            ]
          }
        ],
        canActivate: [AuthGuard],
      },
      {
        path: 'authUtilizationAnalysis',
        component: AuthUtilizationAnalysisComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'addAuthorizations',
        component: AddAuthorizationComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'addParticipantProviderRates/:action',
        component: AddParticipantProviderRatesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'participantProviderRatesList',
        component: ParticipantProviderRatesListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'addPayablePersonalAssistantRates/:action',
        component: AddPayableProviderRatesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'payablePersonalAssistantRates',
        component: PayableProviderRatesListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'addBillablePersonalAssistantRates/:action',
        component: AddBillableProviderRatesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'billablePersonalAssistantRates',
        component: BillableProviderRatesListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'fileTriage',
        component: FileTriageListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'payrollNATPay',
        component: PayrollNatPayListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'fileUploadNotification',
        component: FileUploadNotificationListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'claimBatchesList',
        component: BatchesListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'claimFilesList',
        component: FilesListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'viewClaimsList',
        component: ClaimsListComponent,
        data: {
          breadcrumb: 'Claims',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'viewIgnoredTimesheetsList',
        component: IgnoredTimesheetsListComponent,
        data: {
          breadcrumb: 'Ignored Timesheets',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'billingAdjustment',
        component: TimesheetBillingAdjustmentComponent,
        data: {
          breadcrumb: 'Billing Adjustment',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'billingApprovals',
        component: TimesheetBillingAdjustmentApprovalsComponent,
        data: {
          breadcrumb: 'Billing Approval',
        },
        canActivate: [AuthGuard],
      },
     {
        path:'billingClaimAdjustment',
        component: BillingClaimAdjustmentComponent,
        data: {
          breadcrumb: 'Claims Adjustment',
        },
        canActivate: [AuthGuard],
      }
    ],
    canActivate: [MsalGuard],
  },
  {
    path: '',
    component: DashboardComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'programs',
    component: DashboardComponent,
    canActivate: [MsalGuard],
    data: {
      breadcrumb: 'Provider Leads List',
    },
  },
  {
    path: 'referralLogic',
    component: ReferralLogicComponent,
    data: {
      breadcrumb: 'Provider Leads List',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'confirmation',
    component: MessageComponent,
  },
  {
    path: 'newReferral',
    component: NewReferralComponent,
    children: [
      { path: '', component: ParticipantInformationComponent },
      { path: 'participant_info', component: ParticipantInformationComponent },
      { path: 'contact_details', component: ContactDetailsComponent },
      { path: 'comm_preferences', component: CommPreferenceComponent },
      { path: 'service_details', component: ServiceDetailsComponent },
      { path: 'upload_docs', component: UploadDocsComponent },
      { path: 'signatures', component: UploadSignaturesComponent },
      { path: 'associations', component: NewContactComponent },
      { path: 'forms', component: FormChecklistComponent, data: { isNewReferral: true } },
      { path: 'payment_details', component: PaymentDetailsComponent },
      { path: 'summary', component: SummaryComponent, data: { isNewReferral: true } },
    ],
    canActivate: [AuthGuard],
  }
];
